import { ContentView, queryParamsKeys, ShortContentView } from '../Pages/VideoPlayer/utils/queryParamsKeys';

export const generatePlayerPageViewUrl = (videoId, typeOfContentView = ContentView.PLAYVIEW, playlistId = '') => {
	if (!videoId) {
		throw new Error('videoId is required to generate the PlayerPage URL');
	}

	// Construct base URL with required parameters
	let url = `/PlayerPage?${queryParamsKeys.videoId}=${videoId}&${queryParamsKeys.typeOfContentView}=${typeOfContentView}`;

	// Append playlistId only if it exists
	if (playlistId) {
		url += `&${queryParamsKeys.playlistId}=${playlistId}`;
	}

	return url;
};

export const generateTypeOfContentView = contentType => {
	let contentViewType = '';

	if (
		contentType === ShortContentView.FEATURED ||
		contentType === ContentView.FEATURED ||
		contentType === ContentView.featurePlaylist
	) {
		contentViewType = ContentView.FEATURED;
	} else if (contentType === ShortContentView.PERSONAL || contentType === ContentView.PERSONAL) {
		contentViewType = ContentView.PERSONAL;
	} else if (contentType === ShortContentView.STUDIO || contentType === ContentView.STUDIO) {
		contentViewType = ContentView.STUDIO;
	} else if (contentType === ShortContentView.CLASSES || contentType === ContentView.CLASSES) {
		contentViewType = ContentView.CLASSES;
	} else {
		contentViewType = ContentView.PLAYVIEW;
	}
	return contentViewType;
};
